import {
  // createStore, applyMiddleware,
   combineReducers } from "redux";
 
import { authReducer } from "../redux/reducers/authReducer";
import { bookingReducer } from "../redux/reducers/bookingReducer";
import { vehicleReducer } from "../redux/reducers/vehicleReducer";
import { faqReducer } from "../redux/reducers/faqReducer";
import { contactUsReducer } from "../redux/reducers/contactReducer";
import { paymentReducer } from "../redux/reducers/paymentReducer";
import { dashboardReducer } from "../redux/reducers/dashboardReducer";
import { filterReducer } from "../redux/reducers/filterReducer";
import { sidebarFilterReducer } from "../redux/reducers/sidebarFilterReducer";
import { stripeReducer } from "../redux/reducers/stripeReducer";
import { stripeCardReducer } from "../redux/reducers/StripeCardReducer";
import { commonReducer } from "../redux/reducers/commonReducer";
import { vehicleRecommendationReducer } from "../redux/reducers/vehicleRecommendationReducers";
import { templateReducer } from "../redux/reducers/templateReducer";
import { payoutReducer } from "../redux/reducers/payoutReducers";


const rootReducer = combineReducers({
  auth: authReducer,
  vehicle: vehicleReducer,
  sortFilter: filterReducer,
  sidebarFilter: sidebarFilterReducer,
  booking: bookingReducer,
  contactUs: contactUsReducer,
  faq: faqReducer,
  payment: paymentReducer,
  dashboard: dashboardReducer,
  stripe: stripeReducer,
  stripeCard: stripeCardReducer,
  common: commonReducer,
  template: templateReducer,
  vehicleRecommendation: vehicleRecommendationReducer,
  payout: payoutReducer,
});
 

export default rootReducer;
